import S01 from './s01';
import S02 from './s02';
import { Helmet } from 'react-helmet';

const Product = () => {
  return (
    <main>
      <Helmet>
        <title>LEVRAI | PRODUCTS</title>
        <link rel="canonical" href="https://www.levraiglobal.com/product" />
      </Helmet>
      <S01 />
      <S02 />
    </main>
  );
};

export default Product;
